import React from 'react';
import { Stack, Box, SelectChangeEvent, useTheme } from '@mui/material';
import CalendarIcon from '@/components/icons/calendar';
import StyledSelect from '@/components/common/styledSelect';

export interface FlyoutSectionHeaderProps {
  title?: string;
  showGroupBy?: boolean;
  groupBy?: string;
  onGroupByChange?: (event: SelectChangeEvent, child: React.ReactNode) => void;
}

const groupByOptions = [
  { value: 'Today', label: 'Today' },
  { value: 'LastMonth', label: 'Last Month' },
  { value: 'LastQuarter', label: 'Last Quarter' },
  { value: 'ThisYear', label: 'This Year' },
  { value: 'LastYear', label: 'Last Year' },
];

const FlyoutSectionHeader: React.FC<FlyoutSectionHeaderProps> = ({
  title,
  showGroupBy = false,
  groupBy,
  onGroupByChange,
}) => {
  const theme = useTheme();

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
    >
      <Box sx={{ display: 'flex', gap: '12px' }}>
        {showGroupBy && (
          <StyledSelect
            startAdornment={<CalendarIcon sx={{ marginRight: 1 }} />}
            value={groupBy || 'Today'}
            options={groupByOptions}
            onChange={(e, child) => onGroupByChange?.(e, child)}
          />
        )}
      </Box>
    </Stack>
  );
};

export default React.memo(FlyoutSectionHeader);
